import React, { memo } from 'react';

interface ActionButtonsProps {
  status: 'pending' | 'approved' | 'rejected' | 'checked' | 'consumed';
  isEditing: boolean;
  isSubmitting: boolean;
  isCancelling: boolean;
  onCancelEdit: () => void;
  onSubmit: () => Promise<void>;
  onCancelApplication: () => void;
}

const ActionButtonsComponent: React.FC<ActionButtonsProps> = ({
  status,
  isEditing,
  isSubmitting,
  isCancelling,
  onCancelEdit,
  onSubmit,
  onCancelApplication
}) => {
  if (isEditing) {
    return (
      <div className="fixed bottom-0 left-0 w-full h-20 md:h-24 bg-white border-t border-gray-200 z-40">
        <div className="max-w-[1600px] mx-auto px-4 h-full flex items-center justify-end gap-2 md:gap-0">
          <button
            onClick={onCancelEdit}
            className="w-32 md:w-44 h-12 md:h-16 rounded-sm border border-gray-300 text-gray-700 hover:bg-gray-50 md:mr-4"
          >
            <div className="text-center text-gray-700 text-base md:text-lg font-bold font-['Pretendard'] leading-9">
              취소
            </div>
          </button>
          <button
            onClick={onSubmit}
            disabled={isSubmitting}
            className={`w-32 md:w-44 h-12 md:h-16 ${
              !isSubmitting ? 'bg-[#155acb] hover:bg-[#155acb]/90' : 'bg-gray-400'
            } rounded-sm`}
          >
            <div className="text-center text-white text-base md:text-lg font-bold font-['Pretendard'] leading-9">
              {isSubmitting ? '저장 중...' : '저장하기'}
            </div>
          </button>
        </div>
      </div>
    );
  }

  if (status === 'pending' || status === 'checked') {
    return (
      <div className="fixed bottom-0 left-0 w-full h-20 md:h-24 bg-white border-t border-gray-200 z-40">
        <div className="max-w-[1600px] mx-auto px-4 h-full flex items-center justify-end">
          <button
            onClick={onCancelApplication}
            disabled={isCancelling}
            className="w-24 md:w-[130px] h-10 md:h-11 rounded-sm border border-[#ed5a5a] text-[#ed5a5a] hover:bg-red-50 transition-colors disabled:opacity-50"
          >
            <div className="text-center text-[#ed5a5a] text-sm md:text-base font-bold font-['Pretendard'] leading-9">
              {isCancelling ? '처리 중...' : '신청 취소'}
            </div>
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export const ActionButtons = memo(ActionButtonsComponent);
